import { defineStore } from 'pinia'
import { store } from '../index'
import { ElMessageBox } from 'element-plus'
import { useI18n } from '@/hooks/web/useI18n'
import { loginOutApi } from '@/api/login'
import { useTagsViewStore } from './tagsView'
import { usePermissionStoreWithOut } from './permission'
import router, { resetRouter } from '@/router'

interface UserState {
  userInfo?: any
  token: string
  rememberMe: boolean
  loginInfo?: any
}

export const useUserStore = defineStore('user', {
  state: (): UserState => {
    return {
      userInfo: undefined,
      token: '',
      // 记住我
      rememberMe: true,
      loginInfo: undefined
    }
  },
  getters: {
    getToken(): string {
      return this.token
    },
    getUserInfo(): any | undefined {
      return this.userInfo
    },
    getRememberMe(): boolean {
      return this.rememberMe
    },
    getLoginInfo(): any | undefined {
      return this.loginInfo
    }
  },
  actions: {
    setToken(token: string) {
      this.token = token
    },
    setUserInfo(userInfo?: any) {
      this.userInfo = userInfo
    },
    logoutConfirm() {
      const { t } = useI18n()
      ElMessageBox.confirm(t('common.loginOutMessage'), t('common.reminder'), {
        confirmButtonText: t('common.ok'),
        cancelButtonText: t('common.cancel'),
        type: 'warning'
      })
        .then(async () => {
          const res = await loginOutApi().catch(() => {})
          if (res) {
            this.reset()
          }
        })
        .catch(() => {})
    },
    reset() {
      const tagsViewStore = useTagsViewStore()
      const permissionStore = usePermissionStoreWithOut()
      
      // 清除标签页
      tagsViewStore.delAllViews()
      
      // 重置权限状态，确保重新登录后重新生成路由
      permissionStore.setIsAddRouters(false)
      
      // 重置路由，清除动态添加的路由
      resetRouter()
      
      // 清除用户信息
      this.setToken('')
      this.setUserInfo(undefined)
      
      // 跳转到登录页
      router.replace('/login')
    },
    logout() {
      this.reset()
    },
    setRememberMe(rememberMe: boolean) {
      this.rememberMe = rememberMe
    },
    setLoginInfo(loginInfo: any | undefined) {
      this.loginInfo = loginInfo
    }
  },
  persist: true
})

export const useUserStoreWithOut = () => {
  return useUserStore(store)
}
